export const TravelMarker = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: []
    },
    properties: {
      title: '',
      description: '',
      color: '#4981d4'
    }
  },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: []
      },
      properties: {
        title: '',
        description: '',
        color: '#db6363'
      }
    }]
};



// WEBPACK FOOTER //
// ./src/model/TravelMarker.js